module.exports = __webpack_public_path__ + "img/WTA_PlayerZone_Tablet.498b5c90.jpg";